import { render, staticRenderFns } from "./ShippingProductAdditionalFeeEdit.vue?vue&type=template&id=49e4e116&"
import script from "./ShippingProductAdditionalFeeEdit.vue?vue&type=script&lang=js&"
export * from "./ShippingProductAdditionalFeeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports